import EventHubMixin from '@/mixins/EventHub.js'
import TimeMixin from '@/mixins/Time.js'
import SizesMixin from '@/mixins/Sizes.js'
import MouseMixin from '@/mixins/Mouse.js'

export default
{
    name: 'app-interaction-barrels',

    mixins:
    [
        TimeMixin,
        EventHubMixin,
        SizesMixin,
        MouseMixin
    ],

    props:
    {
        content: { type: Object, default: () => {} }
    },

    data()
    {
        return {
            step: 0,
            hover: false,
            onFrame: false,
            height: 600,
            firstInteraction: false
        }
    },

    created()
    {
        this.height = window.innerHeight
    },

    mounted()
    {
        this.interaction = {}
        this.interaction.cursor = {}
        this.interaction.cursor.forceUpdate = false
        this.interaction.cursor.$element = this.$refs.interactionCursor
        this.interaction.cursor.value = {}
        this.interaction.cursor.value.x = this.sizes.width * 0.5
        this.interaction.cursor.value.y = this.sizes.height * 0.5
        this.interaction.cursor.target = {}
        this.interaction.cursor.target.x = this.interaction.cursor.value.x
        this.interaction.cursor.target.y = this.interaction.cursor.value.y
        this.interaction.cursor.rounded = {}
        this.interaction.cursor.rounded.x = Math.round(this.interaction.cursor.value.x)
        this.interaction.cursor.rounded.y = Math.round(this.interaction.cursor.value.y)

        this.$eventHub.$on('experience.barrels.barrelCursorClick', (_cursor) =>
        {
            this.interaction.cursor.forceUpdate = true

            this.interaction.cursor.target.x = _cursor.x
            this.interaction.cursor.target.y = _cursor.y

            this.step = 1

            window.setTimeout(() =>
            {
                this.step = 2
                this.$eventHub.$emit('sound.play', 'valid')
            }, this.firstInteraction ? 500 : 1500)

            this.firstInteraction = true
        })

        this.$eventHub.$on('experience.barrels.barrelCursorIn', () =>
        {
            this.hover = true
        })

        this.$eventHub.$on('experience.barrels.barrelCursorOut', () =>
        {
            this.hover = false
        })
    },

    destroyed()
    {
        this.$eventHub.$off('experience.barrels.barrelCursorClick')
        this.$eventHub.$off('experience.barrels.barrelCursorIn')
        this.$eventHub.$off('experience.barrels.barrelCursorOut')
    },

    methods:
    {
        onFrameOver()
        {
            this.onFrame = true
        },

        onFrameOut()
        {
            this.onFrame = false
        },

        onResize()
        {
            this.height = window.innerHeight
        },

        onTick()
        {
            if((this.step === 0 || this.interaction.cursor.forceUpdate) && !this.$root.config.platform.mobile)
            {
                this.interaction.cursor.target.x = this.mouse.x
                this.interaction.cursor.target.y = this.mouse.y

                this.interaction.cursor.forceUpdate = false
            }

            this.interaction.cursor.value.x += (this.interaction.cursor.target.x - this.interaction.cursor.value.x) * 0.1
            this.interaction.cursor.value.y += (this.interaction.cursor.target.y - this.interaction.cursor.value.y) * 0.1

            const roundedX = Math.round(this.interaction.cursor.value.x * 10) / 10
            const roundedY = Math.round(this.interaction.cursor.value.y * 10) / 10

            if(roundedX !== this.interaction.cursor.rounded.x || roundedY !== this.interaction.cursor.rounded.y)
            {
                this.interaction.cursor.rounded.x = roundedX
                this.interaction.cursor.rounded.y = roundedY

                this.interaction.cursor.$element.style.transform = `translateX(${this.interaction.cursor.rounded.x}px) translateY(${this.interaction.cursor.rounded.y}px)`
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-interaction-barrels/script.js